import React, { useEffect, useState } from 'react';

const UpdateBanner = () => {
  const [registration, setRegistration] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onUpdate = (e) => {
      setRegistration(e.detail?.registration || null);
      setVisible(true);
    };
    window.addEventListener('comptaai-update-ready', onUpdate);
    return () => window.removeEventListener('comptaai-update-ready', onUpdate);
  }, []);

  const handleReload = () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    } else {
      window.location.reload();
    }
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 10000, background: '#1F2937', color: 'white', padding: '12px 20px',
      borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '16px',
      boxShadow: '0 8px 24px rgba(0,0,0,0.25)', fontFamily: 'Inter, system-ui, sans-serif',
      maxWidth: '92vw'
    }}>
      <span style={{ fontSize: '14px' }}>🔄 Nouvelle version disponible</span>
      <button
        onClick={handleReload}
        style={{
          background: '#1D9E75', border: 'none', color: 'white', padding: '8px 18px',
          borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
          whiteSpace: 'nowrap', transition: 'background 0.2s'
        }}
        onMouseEnter={(e) => { e.target.style.background = '#0F6E56'; }}
        onMouseLeave={(e) => { e.target.style.background = '#1D9E75'; }}
      >
        Actualiser
      </button>
    </div>
  );
};

export default UpdateBanner;
